export default "__VITE_ASSET__C$5B_sci__ 600w";